import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../state";
import { MenuItem, Typography } from "@mui/material";
import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../pages/MyProfile/Collection/Collection";
import { roles } from "../../types/authTypes";
import RedirectService from "../../services/redirectService";

interface MenuElementProps {
  id: string;
  url: string;
  label: string;
  blank: boolean;
}

const MenuElement = (props: MenuElementProps) => {
  const selectedPage = useSelector((state: RootState) => state.selectedPage);
  const loginData = useSelector((state: RootState) => state.login);
  const { setRedirectUrl } = RedirectService();

  const style = {
    fontSize: "16px !important",
    fontWeight: 600,
    color: selectedPage.page === props.id ? "#4663ff" : "#3c3c40",
    fontStyle: "italic",
  };

  // Check if user is visitor and clicking on login-protected pages
  const isVisitor = loginData.role === roles.VISITOR;
  const requiresLogin =
    props.id === "menu-community" || props.id === "menu-myCollection";

  const handleClick = (event: React.MouseEvent) => {
    if (isVisitor && requiresLogin) {
      event.preventDefault();
      // Store the intended URL for redirect after login
      if (props.id === "menu-myCollection") {
        // For My Collection, we'll redirect to user's profile after login
        setRedirectUrl("/my-collection-redirect");
      } else {
        setRedirectUrl(props.url);
      }
      // Redirect to sign-up page
      window.location.href = "/sign-up";
    }
  };

  const getTargetUrl = () => {
    if (props.id === "menu-myCollection") {
      return (
        props.url +
        "/" +
        loginData.userId +
        "/" +
        COLLECTION_TAB.COLLECTION +
        "/" +
        COLLECTION_SECTION.OVERVIEW
      );
    }
    return props.url;
  };

  return (
    <Link
      to={getTargetUrl()}
      target={props.blank ? "_blank" : ""}
      style={{ display: "block", width: "100%" }}
      onClick={handleClick}
    >
      <MenuItem>
        <Typography sx={style}>{props.label}</Typography>
      </MenuItem>
    </Link>
  );
};

export default MenuElement;
